// extracted by mini-css-extract-plugin
var _1 = "ProfileContactsWidgetFormButtons-modulebuttons__COxN6";
export { _1 as "buttons" }
